module.exports = __webpack_public_path__ + "static/img/wei.dbce7865.png";